import * as React from 'react';
import './GroupsPanel.css';
import { inject, observer } from 'mobx-react';
import { AppStore } from '../../../../stores';
import { IUser } from '../../../../interfaces/IUser';
import AdminService from '../../../../services/AdminService';
import UserSearchPopup from '../../../userSearchPopup/UserSearchPopup';
import GroupService from '../../../../services/GroupService';
import { IGroupMemberInfo } from '../../../../interfaces/IGroupMemberInfo';
import GroupDeletePopup from './groupDeletePopup/GroupDeletePopup';

export interface IProps {
  id: string;
  appStore?: AppStore;
  save: () => void;
  delete: () => void;
}

export interface IState {
  searchValueMember: string;
  searchValueAdmin: string;
  searchValueOwner: string;
  usersToRender: JSX.Element[];
  loadingUsers: boolean;
  showMembers: boolean;
  members?: IUser[];
  showAdmins: boolean;
  admins?: IUser[];
  showOwners: boolean;
  owners?: IUser[];
  missingMembers?: IUser[];
  newInvite?: string;
}

export interface IState {
  selectedAudience: "all" | "teams" | "users";
}

@inject('appStore')
@observer
export default class GroupsPanel extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      selectedAudience: "all",
      searchValueMember: "",
      searchValueAdmin: "",
      searchValueOwner: "",
      usersToRender: [],
      loadingUsers: false,
      showMembers: false,
      showAdmins: false,
      showOwners: false
    }
  }

  private getAdmins() {
    const admins = [];
    this.props.appStore!.groupToEdit.admins.forEach((admin: string) => {
      AdminService.getUserNameFromId(admin).then((user: IUser) => {
        admins.push(user);
        this.setState({ admins });
      });
    });
  }

  private getOwners() {
    const owners = [];
    this.props.appStore!.groupToEdit.owners.forEach((owner: string) => {
      AdminService.getUserNameFromId(owner).then((user: IUser) => {
        owners.push(user);
        this.setState({ owners });
      });
    });
  }

  private getMissingAnswers() {
    const groupId = this.props.appStore?.groupToEdit?.objectId;
    if (!groupId) {
      this.setState({ missingMembers: [] });
      return;
    }

    GroupService.getGroupMemberInfoForGroup(groupId).then((groupMembersInfo: IGroupMemberInfo[]) => {
      console.log(groupMembersInfo);
      const existingMemberIds = new Set((groupMembersInfo || []).map((memberInfo: IGroupMemberInfo) => memberInfo.userId));
      const invites = this.props.appStore!.groupToEdit?.invites || [];
      const missingMembers: IUser[] = [];

      Promise.all(invites.map((invite: string) => AdminService.getUsers(invite))).then((inviteMatches: IUser[][]) => {
        invites.forEach((invite: string, index: number) => {
          const users = inviteMatches[index] || [];
          const matchingUser = users.find((user: IUser) => user?.username?.toLowerCase() === invite.toLowerCase());

          if (matchingUser && !existingMemberIds.has(matchingUser.id)) {
            missingMembers.push(matchingUser);
          }
        });
        this.setState({ missingMembers });
      });
    });
  }

  render() {
    const admins = [];
    if (this.state.admins?.length > 0 && this.state.showAdmins) {
      this.state.admins.forEach((admin: IUser) => {
        admins.push(
          <div
            key={"groupMember-" + admin}
            className="emailLabel"
          >
            {admin?.name}
            <div
              className="emailLabelDeleteBtn"
              onClick={() => {
                this.props.appStore!.groupToEdit.admins = this.props.appStore!.groupToEdit?.admins.filter(savedAdmin => savedAdmin !== admin.id);
              }}
            />
          </div>
        );
      });
    }
    const owners = [];
    if (this.state.owners?.length > 0 && this.state.showOwners) {
      this.state.owners.forEach((owner: IUser) => {
        owners.push(
          <div
            key={"groupMember-" + owner}
            className="emailLabel"
          >
            {owner?.name}
            <div
              className="emailLabelDeleteBtn"
              onClick={() => {
                this.props.appStore!.groupToEdit.owners = this.props.appStore!.groupToEdit?.owners.filter(savedAdmin => savedAdmin !== owner.id);
              }}
            />
          </div>
        );
      });
    }
    return (
      <div>
        <div
          className="groupEditPanelWrapper"
          style={{
            visibility: this.props.appStore!.groupToEdit != undefined ? "visible" : "hidden"
          }}
          onClick={() => {
            this.props.appStore!.groupToEdit = undefined;
          }}
        />
        <div
          className="groupEditPanel"
          style={{
            right: this.props.appStore!.groupToEdit != undefined ? 0 : -620
          }}
        >
          <div className="editPanelCloseBtn"
            onClick={() => this.props.appStore!.groupToEdit = undefined}
          />
          <h3>{this.props.appStore!.groupToEdit?.objectId ? window.loc.strings.updateGroup : window.loc.strings.createGroup}</h3>
          {this.props.appStore!.groupToEdit != undefined &&
            <div style={{
              position: "relative",
              float: "left",
              width: "100%"
            }}>
              <div className="inputFieldLabel">{window.loc.strings.groupName}</div>
              <input
                type="text"
                value={this.props.appStore!.groupToEdit.name}
                onChange={(event: any) => {
                  this.props.appStore!.groupToEdit.name = event.target.value;
                }}
              />
              <div className="inputFieldLabel">{window.loc.strings.messageToMembers}</div>
              <textarea
                onChange={(event: any) => this.props.appStore!.groupToEdit.description = event.target.value}
              >
                {this.props.appStore!.groupToEdit?.description}
              </textarea>

              {/* Admins */}
              {(this.props.appStore!.groupToEdit?.admins?.find((admin) => admin === this.props.appStore!.user?.id) || this.props.appStore!.user.userType === "admin") && (
                <div
                  style={{
                    marginTop: 20,
                    float: "left",
                    clear: "both"
                  }}
                >
                  <div className="inputFieldLabel">{window.loc.strings.groupAdmins}</div>
                  <div className='groupTypeDescription'>{window.loc.strings.groupAdminsDescription}</div>
                  <div className="groupMembers">
                    {this.state.showAdmins ? admins : (this.props.appStore!.groupToEdit?.admins?.length === 1 ? window.loc.strings.oneAdmin : `${this.props.appStore!.groupToEdit?.admins?.length ?? 0} ${window.loc.strings.admins}`)}
                  </div>
                  <button
                    onClick={() => this.setState({ showAdmins: !this.state.showAdmins }, () => this.getAdmins())}
                    disabled={this.props.appStore!.groupToEdit?.admins == undefined || this.props.appStore!.groupToEdit?.admins?.length === 0}
                    style={{
                      opacity: this.props.appStore!.groupToEdit?.admins == undefined || this.props.appStore!.groupToEdit?.admins?.length === 0 ? 0.5 : 1
                    }}
                  >
                    {this.state.showAdmins ? window.loc.strings.hideAdmins : window.loc.strings.showAdmins}
                  </button>
                  <div className="inputFieldLabel">{window.loc.strings.addGroupAdmins}</div>
                  <input
                    type="text"
                    placeholder={window.loc.strings.searchForUsers}
                    value={this.state.searchValueAdmin}
                    style={{
                      width: "100%"
                    }}
                    onChange={(event: any) => {
                      this.setState({ searchValueAdmin: event.target.value.toLowerCase() });
                    }}
                  />
                  <div
                    className="searchButton"
                    onClick={() => {
                      const usersToRender = [];
                      this.setState({ loadingUsers: true });
                      AdminService.getUsers(this.state.searchValueAdmin).then((users: IUser[]) => {
                        if (users && users.length > 0) {
                          users.forEach(async (user: IUser) => {
                            usersToRender.push(
                              <div
                                className='emailLabel'
                                onClick={() => {
                                  if (!this.props.appStore!.groupToEdit.admins) {
                                    this.props.appStore!.groupToEdit.admins = [];
                                  }
                                  this.props.appStore!.groupToEdit.admins.push(user.id);
                                  this.setState({
                                    usersToRender: [],
                                    searchValueMember: undefined,
                                    searchValueAdmin: undefined,
                                    searchValueOwner: undefined,
                                    showMembers: false,
                                    showAdmins: false,
                                    showOwners: false
                                  });
                                }}
                              >
                                {`${user.name} (${user.username})`}
                              </div>
                            );
                          });
                          this.setState({ usersToRender, loadingUsers: false });
                        } else {
                          this.setState({ loadingUsers: false });
                        }
                      });
                    }}
                  />
                </div>
              )}
              {/* Organizers */}
              {(this.props.appStore!.groupToEdit?.owners?.find((owner) => owner === this.props.appStore!.user?.id) || this.props.appStore!.user.userType === "admin") && (
                <div
                  style={{
                    marginTop: 20,
                    float: "left",
                    clear: "both"
                  }}
                >
                  <div className="inputFieldLabel">{window.loc.strings.groupOwners}</div>
                  <div className='groupTypeDescription'>{window.loc.strings.groupOwnersDescription}</div>
                  <div className="groupMembers">
                    {this.state.showOwners ? owners : (this.props.appStore!.groupToEdit?.owners?.length === 1 ? window.loc.strings.oneOwner : `${this.props.appStore!.groupToEdit?.owners?.length ?? 0} ${window.loc.strings.owners}`)}
                  </div>
                  <button
                    onClick={() => this.setState({ showOwners: !this.state.showOwners }, () => this.getOwners())}
                    disabled={this.props.appStore!.groupToEdit?.owners == undefined || this.props.appStore!.groupToEdit?.owners?.length === 0}
                    style={{
                      opacity: this.props.appStore!.groupToEdit?.owners == undefined || this.props.appStore!.groupToEdit?.owners?.length === 0 ? 0.5 : 1
                    }}
                  >
                    {this.state.showOwners ? window.loc.strings.hideOwners : window.loc.strings.showOwners}
                  </button>
                  <div className="inputFieldLabel">{window.loc.strings.addGroupOwners}</div>
                  <input
                    type="text"
                    placeholder={window.loc.strings.searchForUsers}
                    value={this.state.searchValueOwner}
                    style={{
                      width: "100%"
                    }}
                    onChange={(event: any) => {
                      this.setState({ searchValueOwner: event.target.value.toLowerCase() });
                    }}
                  />
                  <div
                    className="searchButton"
                    onClick={() => {
                      const usersToRender = [];
                      this.setState({ loadingUsers: true });
                      AdminService.getUsers(this.state.searchValueOwner).then((users: IUser[]) => {
                        if (users && users.length > 0) {
                          users.forEach(async (user: IUser) => {
                            usersToRender.push(
                              <div
                                className='emailLabel'
                                onClick={() => {
                                  if (!this.props.appStore!.groupToEdit.owners) {
                                    this.props.appStore!.groupToEdit.owners = [];
                                  }
                                  this.props.appStore!.groupToEdit.owners.push(user.id);
                                  this.setState({
                                    usersToRender: [],
                                    searchValueMember: undefined,
                                    searchValueAdmin: undefined,
                                    searchValueOwner: undefined,
                                    showMembers: false,
                                    showAdmins: false,
                                    showOwners: false
                                  });
                                }}
                              >
                                {`${user.name} (${user.username})`}
                              </div>
                            );
                          });
                          this.setState({ usersToRender, loadingUsers: false });
                        } else {
                          this.setState({ loadingUsers: false });
                        }
                      });
                    }}
                  />
                </div>
              )}
              {/* Invites */}
              <div
                className='groupInvites'
                style={{
                  marginTop: 20,
                  float: "left",
                  clear: "both"
                }}
              >
                <div className="inputFieldLabel">{window.loc.strings.invites}</div>
                <div className='groupTypeDescription'>{window.loc.strings.invitesDescription}</div>
                <div style={{
                  float: "left",
                  width: "100%",
                  marginTop: 20
                }}>
                  {this.props.appStore!.groupToEdit.invites?.length > 0 ?
                    (this.props.appStore!.groupToEdit.invites?.map((invite) => (
                      <div
                        key={"invites_" + invite}
                        className="emailLabel"
                      >
                        {invite}
                        <div
                          className="emailLabelDeleteBtn"
                          onClick={() => {
                            this.props.appStore!.groupToEdit.invites = this.props.appStore!.groupToEdit?.invites.filter(savedInvite => savedInvite !== invite);
                          }}
                        />
                      </div>
                    )))
                    :
                    (
                      <i>{window.loc.strings.noInvites}</i>
                    )
                  }
                  <input
                    type="text"
                    value={this.state.newInvite}
                    placeholder='Indtast e-mail på den du vil invitere...'
                    onChange={(event: any) => {
                      this.setState({ newInvite: event.target.value.toLowerCase() });
                    }}
                  />
                  <button
                    onClick={() => {
                      if (this.state.newInvite && this.state.newInvite.indexOf("@") > 0 && this.state.newInvite.indexOf(".") > 0) {
                        if (!this.props.appStore!.groupToEdit.invites) {
                          this.props.appStore!.groupToEdit.invites = [];
                        }
                        this.props.appStore!.groupToEdit.invites.push(this.state.newInvite);
                        this.setState({ newInvite: undefined });
                      } else {
                        alert("Please enter a valid email address");
                      }
                    }}
                  >
                    {window.loc.strings.addInvite}
                  </button>

                  <div className='groupTypeDescription'>{window.loc.strings.teamTestInvitationLinkDescription}</div>
                  <div
                    className='teamTestInvitationLink'
                    style={{
                      cursor: this.props.appStore!.groupToEdit.objectId ? "pointer" : "default",
                      opacity: this.props.appStore!.groupToEdit.objectId ? 1 : 0.5
                    }}
                    onClick={this.props.appStore!.groupToEdit.objectId ? () => {
                      navigator.clipboard.writeText(`https://dojo.mindjuice.com?teamtestid=${this.props.appStore!.groupToEdit.objectId}`);
                    } : undefined}
                  >
                    <div>{this.props.appStore!.groupToEdit.objectId ? `https://dojo.mindjuice.com?teamtestid=${this.props.appStore!.groupToEdit.objectId}` : window.loc.strings.linkNotReady}</div>
                    <div>{window.loc.strings.copyLink}</div>
                  </div>
                </div>
              </div>
              {/* Missing answers */}
              <div style={{
                marginTop: 20,
                float: "left",
                clear: "both"
              }}>
                <div className="inputFieldLabel">{window.loc.strings.missingAnswers}</div>
                <button
                  onClick={() => this.getMissingAnswers()}
                >
                  {window.loc.strings.missingMembers}
                </button>
                {this.state.missingMembers && this.state.missingMembers.length > 0 &&
                  <div style={{
                    marginTop: 20,
                    float: "left",
                    clear: "both"
                  }}>
                    {this.state.missingMembers.map((member: IUser) => (
                      <div
                        key={"missingMember-" + member.id}
                        className="emailLabel"
                      >
                        {member.name} ({member.username})
                      </div>
                    ))}
                  </div>
                }
              </div>
              <div
                style={{
                  marginTop: 20,
                  float: "left",
                  clear: "both"
                }}
              >
                <button
                  onClick={() => this.props.save()}
                >
                  {this.props.appStore!.groupToEdit.objectId !== undefined && this.props.appStore!.groupToEdit.objectId !== "new" ? window.loc.strings.update : window.loc.strings.create}
                </button>
                <button
                  style={{
                    marginLeft: 10
                  }}
                  onClick={() => {
                    this.props.appStore!.groupToEdit = undefined;
                    this.props.appStore!.productToNotify = undefined;
                  }}
                >
                  {window.loc.strings.cancel}
                </button>
                <button
                  style={{
                    marginLeft: 10,
                    backgroundColor: "red",
                  }}
                  onClick={() => {
                    this.props.appStore!.groupToDelete = this.props.appStore!.groupToEdit;
                  }}
                >
                  {window.loc.strings.delete}
                </button>
              </div>
            </div >
          }
        </div>
        {
          this.state.usersToRender?.length > 0 &&
          <UserSearchPopup
            users={this.state.usersToRender}
            close={() => {
              this.setState({
                usersToRender: [],
                searchValueMember: undefined,
                searchValueAdmin: undefined,
                showMembers: false,
                showAdmins: false
              }, () => this.forceUpdate());
            }}
          />
        }
        {
          this.props.appStore!.groupToDelete &&
          <GroupDeletePopup
            onClose={() => {
              this.props.appStore!.groupToDelete = undefined;
            }}
            onDelete={() => {
              GroupService.deleteGroup(this.props.appStore!.groupToDelete.objectId).then(() => {
                this.props.appStore!.groupToDelete = undefined;
                this.props.delete();
              });
            }}
          />
        }
      </div >
    );
  }
}